var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZipColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.36,
    height: 22.76,
    viewBox: "0 0 17.36 22.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ZIP",
    transform: "translate(-1 -0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M18.35,22.08a.681.681,0,0,1-.67.69H1.67A.681.681,0,0,1,1,22.08V.7A.681.681,0,0,1,1.67.01H13.48c.87.93,4.51,4.47,4.88,4.94V22.07Z",
    fill: "#e0f4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M18.35,15.86H1v6.2a.681.681,0,0,0,.67.69H17.69a.681.681,0,0,0,.67-.69V15.87Z",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M13.51.02V4.31a.628.628,0,0,0,.62.61h4.18Z",
    fill: "#99badb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M6.83,20.85H8.59v.46H6.13v-.37l1.71-2.47H6.14v-.46H8.53v.36L6.82,20.85Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M9.69,21.31H9.12v-3.3h.57Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M10.97,20.08v1.23H10.4v-3.3h1.26a1.6,1.6,0,0,1,.51.08,1.185,1.185,0,0,1,.38.22.938.938,0,0,1,.23.33,1.122,1.122,0,0,1,.08.42,1.176,1.176,0,0,1-.08.43.821.821,0,0,1-.23.32.922.922,0,0,1-.38.2,1.964,1.964,0,0,1-.51.07h-.69Zm0-.46h.69a.788.788,0,0,0,.28-.04.666.666,0,0,0,.2-.12.418.418,0,0,0,.11-.18.8.8,0,0,0,.03-.23.732.732,0,0,0-.03-.22.524.524,0,0,0-.11-.19.464.464,0,0,0-.2-.13.778.778,0,0,0-.28-.05h-.69v1.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1716",
    "data-name": "Rectangle 1716",
    width: 1.41,
    height: 0.94,
    transform: "translate(7.52 6.92)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1717",
    "data-name": "Rectangle 1717",
    width: 1.41,
    height: 0.94,
    transform: "translate(8.94 7.86)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1718",
    "data-name": "Rectangle 1718",
    width: 1.41,
    height: 0.94,
    transform: "translate(8.94 5.98)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1719",
    "data-name": "Rectangle 1719",
    width: 1.41,
    height: 0.94,
    transform: "translate(7.52 8.79)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1720",
    "data-name": "Rectangle 1720",
    width: 1.41,
    height: 0.94,
    transform: "translate(8.94 9.73)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M9.93,13.57,9.51,11.3a.247.247,0,0,0-.24-.2H8.55a.238.238,0,0,0-.24.2l-.42,2.27a.246.246,0,0,0,.24.29H9.7a.251.251,0,0,0,.24-.29Zm-.67.08H8.55a.2.2,0,1,1,0-.4h.71a.2.2,0,1,1,0,.4Z",
    fill: "#5b5b5b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipColorIcon);
export default __webpack_public_path__ + "static/media/zip-color-icon.e6a23dc23e2f252b9fd957bd7c058a35.svg";
export { ForwardRef as ReactComponent };